export * as V1 from './interfaces.v1';
export * as V2 from './interfaces.v2';
export * as V3 from './interfaces.v3';
export * from './OnderfulResponseInterface';
export * as Current from './interfaces.v3';
export * as CarrierCapabilities from './carrier-capabilities.interfaces';
export * as PortalAiSettings from './portal-ai-settings.interfaces';
export * as Recommendations from './recommendation.interfaces';
